import { createContext } from 'react';
import type { LogoutReason } from 'features/auth/utils/logoutSignal';

export type LogoutOptions = {
  reason?: LogoutReason;
};

export type AuthContextValue = {
  logout: (options?: LogoutOptions) => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined
);
